export default () => (
  <svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      opacity="0.87"
      x="10.8047"
      y="8.04021"
      width="3.2"
      height="8"
      rx="1.6"
      transform="rotate(135 10.8047 8.04021)"
      fill="#3C3C43"
      fillOpacity="0.6"
    />
    <rect
      opacity="0.75"
      x="8.5"
      y="10.4"
      width="3.2"
      height="8"
      rx="1.6"
      transform="rotate(90 8.5 10.4)"
      fill="#3C3C43"
      fillOpacity="0.6"
    />
    <rect
      opacity="0.63"
      x="8.53906"
      y="13.6971"
      width="3.2"
      height="8"
      rx="1.6"
      transform="rotate(45 8.53906 13.6971)"
      fill="#3C3C43"
      fillOpacity="0.6"
    />
    <rect
      opacity="0.51"
      x="10.8984"
      y="16"
      width="3.2"
      height="8"
      rx="1.6"
      fill="#3C3C43"
      fillOpacity="0.6"
    />
    <rect
      opacity="0.39"
      x="22.1172"
      y="19.3539"
      width="3.2"
      height="8"
      rx="1.6"
      transform="rotate(135 22.1172 19.3539)"
      fill="#3C3C43"
      fillOpacity="0.6"
    />
    <rect
      opacity="0.27"
      x="24.5"
      y="10.4"
      width="3.2"
      height="8"
      rx="1.6"
      transform="rotate(90 24.5 10.4)"
      fill="#3C3C43"
      fillOpacity="0.6"
    />
    <rect
      opacity="0.15"
      x="19.8555"
      y="2.38339"
      width="3.2"
      height="8"
      rx="1.6"
      transform="rotate(45 19.8555 2.38339)"
      fill="#3C3C43"
      fillOpacity="0.6"
    />
    <rect
      x="10.8984"
      width="3.2"
      height="8"
      rx="1.6"
      fill="#3C3C43"
      fillOpacity="0.6"
    />
  </svg>
);
